import React from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import ProfileFieldGrid from './ProfileFieldGrid'

const Education = props => {
  const { authenticationStore } = props
  const { currentUser } = authenticationStore
  const fields = [
    {
      title: 'Trình độ giáo dục phổ thông',
      value: currentUser?.other?.education_level,
    },
    {
      title: 'Ngày vào Đảng Cộng sản Việt Nam',
      value: currentUser?.other?.join_date,
    },
    {
      title: 'Trình độ chuyên môn cao nhất',
      value: currentUser?.other?.qualification,
    },
    { title: 'Ngày chính thức', value: currentUser?.other?.official_date },
    {
      title: 'Lý luận chính trị',
      value: currentUser?.other?.political_theory,
    },
    {
      title: 'Ngày tham gia tổ chức chính trị xã hội',
      value: currentUser?.other?.join_political,
    },
    { title: 'Tin học', value: currentUser?.other?.IT },
    {
      title: 'Ngày nhập ngũ',
      value: currentUser?.other?.date_of_enlistment,
    },
    { title: 'Ngoại ngữ', value: currentUser?.other?.foreign_language },
    {
      title: 'Ngày xuất ngũ',
      value: currentUser?.other?.demobilization_date,
    },
    {
      title: 'Quản lý nhà nước',
      value: currentUser?.other?.state_management,
    },
    { title: 'Quân hàm cao nhất', value: currentUser?.other?.army_rank },
    { title: 'Khen thưởng', value: currentUser?.other?.laudatory },
    { title: 'Sở trường công tác', value: currentUser?.other?.forte },
    { title: 'Kỷ luật', value: currentUser?.other?.discipline },
    {
      title: 'Danh hiệu được phong tặng cao nhất',
      value: currentUser?.other?.title,
    },
  ]

  return <ProfileFieldGrid fields={fields} />
}

Education.propTypes = {
  authenticationStore: PropTypes.shape({
    currentUser: PropTypes.shape({
      other: PropTypes.shape({
        education_level: PropTypes.string,
        join_date: PropTypes.string,
        qualification: PropTypes.string,
        official_date: PropTypes.string,
        political_theory: PropTypes.string,
        join_political: PropTypes.string,
        IT: PropTypes.string,
        date_of_enlistment: PropTypes.string,
        foreign_language: PropTypes.string,
        demobilization_date: PropTypes.string,
        state_management: PropTypes.string,
        army_rank: PropTypes.string,
        laudatory: PropTypes.string,
        forte: PropTypes.string,
        discipline: PropTypes.string,
        title: PropTypes.string,
      }),
    }),
  }),
}

export default inject('authenticationStore')(observer(Education))
